import { createFileRoute } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import { chatSidePanelOpenAtom } from '@/features/chat/store';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts',
)({
  onEnter: () => getDefaultStore().set(chatSidePanelOpenAtom, true),
});
